import React from 'react';
import Dots from './component';

export default React.memo(Dots);
